// extracted by mini-css-extract-plugin
export default {"label":"BillingCalculationFeeChangeChart_label__TocYi"};